import OffCanvas from '../../components/offCanvas';
import { FiHelpCircle, FiLogOut } from 'react-icons/fi';
import { NavLink } from 'react-router-dom';
import { logout } from '../../services/authService';
import { largeDate } from '../../utils/constants';
import config from '../../configs/config';

async function LogOutAction() {
  await logout();
  window.location = (config.prefix ? '/' + config.prefix_name : '') + '/login';
}

const Profile = ({ id, user }) => {
  const { first_name, last_name } = user;
  const name = first_name + ' ' + last_name;
  const shortname = name.length > 0 ? first_name[0] + last_name[0] : first_name[0];
  const info = {
    email: 'Email',
    first_name: 'First Name',
    last_name: 'Last Name',
    created_date: 'Created On',
    last_modified: 'Last Modified',
    expires_on: 'Password expiry'
  };

  const formatter = (column) => {
    if (column === 'created_date' || column === 'last_modified' || column === 'expires_on') {
      let last_upd = new Date(user[column] + 'Z');
      return last_upd.toLocaleString(undefined, largeDate);
    } else if (column.includes('is_')) {
      return user[column] ? 'Yes' : 'No';
    } else {
      return user[column];
    }
  };

  //Component 1 - Header
  const Header = (
    <div className='row m-0 align-items-center name'>
      <div className='shortname'>{shortname}</div>
      <div className='col'>
        <h6 className='m-0'>{name}</h6>
      </div>
    </div>
  );

  //Component 2 - Body
  const PersonalInfo = (
    <div className='row m-0 pt-4 pb-4 align-items-center userinfo'>
      <div className='mb-3 w-100 title d-flex'>
        <div className='flex-fill pl-0'>Profile information</div>
        {/* <NavLink to='/me' style={{ textDecoration: 'none', fontWeight: 600 }}>
          Edit
        </NavLink> */}
      </div>
      {Object.keys(info).map((x, i) => {
        let value = formatter(x);
        return (
          <p className='w-100 mb-1' key={i}>
            {info[x]}:
            <span className='bold' style={{ overflowWrap: 'anywhere' }}>
              {'  '}
              {value}
            </span>
          </p>
        );
      })}
    </div>
  );

  //Component 3 - Footer
  const Footer = (
    <>
      <div className='row m-0 mt-3 align-items-center signout' onClick={() => LogOutAction()}>
        <span to='' style={{ textDecoration: 'none' }}>
          <FiLogOut size={20} className='me-2' />
          Sign Out
        </span>
      </div>
      <div className='row m-0 align-items-center signout'>
        <NavLink to='/faqs' style={{ textDecoration: 'none' }}>
          <FiHelpCircle size={20} className='me-2' />
          Check Frequently Asked Questions
        </NavLink>
      </div>
    </>
  );

  // Main Body
  const body = (
    <div id='profilepane'>
      {Header}
      {PersonalInfo}
      {Footer}
    </div>
  );

  return <OffCanvas id={id} header={<div>Profile Settings</div>} body={body} />;
};

export default Profile;
